import type { CidrBlock } from '../../apps/cidr-planner/types';
import type { DisplayLang } from '../../../shared/utils/pageDisplay';
import { CidrSheet } from './CidrSheet';

type AwsModeConfirmDialogProps = {
  blocksToRemove: CidrBlock[];
  lang: DisplayLang;
  onClose: () => void;
  onConfirm: () => void;
};

const TEXT = {
  ja: {
    title: 'AWS VPC モードに切り替え',
    message: (count: number) =>
      `/28 より細かいサブネット（${count} 件）を削除する必要があります。`,
    listLabel: '削除されるサブネット',
    cancel: 'キャンセル',
    confirm: '削除して切り替え',
    close: '閉じる',
  },
  en: {
    title: 'Switch to AWS VPC mode',
    message: (count: number) =>
      `${count} subnet(s) smaller than /28 must be removed.`,
    listLabel: 'Subnets to remove',
    cancel: 'Cancel',
    confirm: 'Remove and switch',
    close: 'Close',
  },
} as const;

export function AwsModeConfirmDialog({
  blocksToRemove,
  lang,
  onClose,
  onConfirm,
}: AwsModeConfirmDialogProps) {
  const t = TEXT[lang];

  return (
    <CidrSheet title={t.title} closeLabel={t.close} onClose={onClose}>
      <p className="cidr-sheet__hint">{t.message(blocksToRemove.length)}</p>
      <div className="cidr-sheet__field">
        <span className="cidr-sheet__label">{t.listLabel}</span>
        <ul className="cidr-sheet__preview-list">
          {blocksToRemove.map((block) => (
            <li key={block.id}>
              {block.name ? `${block.name}: ` : ''}
              {block.cidr}
            </li>
          ))}
        </ul>
      </div>
      <div className="cidr-sheet__actions">
        <button type="button" className="cidr-sheet__btn" onClick={onClose}>
          {t.cancel}
        </button>
        <button
          type="button"
          className="cidr-sheet__btn cidr-sheet__btn--danger"
          onClick={onConfirm}
        >
          {t.confirm}
        </button>
      </div>
    </CidrSheet>
  );
}
